export class VariantiColore{
    constructor(){
        //this.pzDisponibili,
        //this.pzOpzionati,
        this.popOverText,
        this.imgAltText,
        this.imgSource,
        this.imgFileName,
        this.imgFileNameZoom,
        this.imgTitle,
        this.urlScheda;
        this.codVar1;
    }
}